import { render } from "./OpenApiEditor.vue?vue&type=template&id=02d4bde3"
import script from "./OpenApiEditor.vue?vue&type=script&lang=js"
export * from "./OpenApiEditor.vue?vue&type=script&lang=js"

import "./OpenApiEditor.vue?vue&type=style&index=0&id=02d4bde3&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__